import nxModule from 'nxModule';

const templateUrl = require('./gl-transactions.template.html');


nxModule.component('glTransactions', {
  templateUrl,
});